import React from 'react'
import { Image, ImageURISource } from 'react-native'

const ImageWithZoom = ({ image }: { image: ImageURISource }) => {
  return <Image style={{ height: 102, width: 102 }} source={image} />
}

export default ImageWithZoom
